import { Link } from "react-router-dom";

const LEGAL_LINKS = [
  { to: "/refund-policy", label: "Refund policy" },
  { to: "/privacy-policy", label: "Privacy policy" },
  { to: "/terms", label: "Terms of service" },
  { to: "/cancellation-policy", label: "Cancellation policy" },
];

const TOOL_LINKS = [
  { to: "/paintbooth", label: "Paint Booth" },
  { to: "/uv-studio", label: "UV Studio" },
  { to: "/blinklab", label: "Blinklab" },
  { to: "/easy-meta", label: "EasyMeta" },
  { to: "/pack-bench", label: "PackBench" },
  { to: "/code-smith", label: "Code Smith" },
  { to: "/script-docs", label: "Script Docs" },
  { to: "/eup-viewer", label: "EUP Viewer" },
];

export function LegalFooter() {
  return (
    <footer className="w-full border-t border-border/60 bg-muted/40 text-foreground">
      <div className="mx-auto grid max-w-[1840px] gap-10 px-6 py-14 sm:px-10 lg:grid-cols-[1.2fr_1fr_1fr] lg:px-24">
        <div>
          <Link to="/" className="inline-flex items-center gap-3 text-2xl font-semibold tracking-[-0.05em]">
            <span className="grid h-10 w-10 place-items-center overflow-hidden rounded-xl">
              <img
                src="/logo.png"
                alt="The Workshop logo"
                className="h-8 w-8 object-contain dark:invert-0 invert"
              />
            </span>
            The Workshop
          </Link>
          <p className="mt-6 max-w-sm text-lg leading-7 tracking-[-0.03em] text-muted-foreground">
            The browser workspace for serious FiveM creators.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.09em] text-muted-foreground/70">Tools</p>
          <div className="mt-5 grid grid-cols-2 gap-3 text-base">
            {TOOL_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-muted-foreground transition hover:text-foreground"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-[0.09em] text-muted-foreground/70">Legal</p>
          <div className="mt-5 grid gap-3 text-base">
            {LEGAL_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-muted-foreground transition hover:text-foreground"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-border/60 px-4 py-5 text-center text-sm text-muted-foreground/80">
        Built for creators who ship assets, resources, and servers.
      </div>
    </footer>
  );
}
